import type { DuplicateAcknowledgementResponse, DuplicateFlag } from '../types';
import { formatUsDate } from './runContext';
import { runStatusLabel } from '../types';

/** Plain-language reason a run is flagged, from the server's match value. */
export function matchLabel(match: string): string {
  switch (match) {
    case 'IdenticalPeriodAndCheckDate':
      return 'same pay period and pay day';
    case 'OverlappingPeriod':
      return 'overlapping pay period';
    case 'SameCheckDate':
      return 'same pay day';
    default:
      return match;
  }
}

function otherStatusLabel(kind: string, status: string): string {
  // A Payroll Review run's status is Payroll Review's own (PendingApproval, Approved); a Custom Pay Run still being prepared uses this module's.
  return kind === 'PayrollReview' || status === 'PendingApproval' || status === 'Approved' || status === 'Rejected'
    ? status.replace(/([a-z])([A-Z])/g, '$1 $2')
    : runStatusLabel(status);
}

/** "Bonus custom pay run (Calculated)" / "Payroll Review run (Approved)". */
export function describeOtherRun(f: Pick<DuplicateFlag, 'otherRunKind' | 'otherRunType' | 'otherRunStatus'> | Pick<DuplicateAcknowledgementResponse, 'otherRunKind' | 'otherRunStatus'> & { otherRunType?: string | null }): string {
  const what = f.otherRunKind === 'PayrollReview' ? 'Payroll Review run' : `${f.otherRunType ?? ''} custom pay run`.trim();
  return `${what.charAt(0).toUpperCase()}${what.slice(1)} (${otherStatusLabel(f.otherRunKind, f.otherRunStatus)})`;
}

export function describeFlagDates(f: DuplicateFlag): string {
  return `${formatUsDate(f.otherPeriodStartDate)} - ${formatUsDate(f.otherPeriodEndDate)}, pay day ${formatUsDate(f.otherCheckDate)}`;
}
